import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchBVQuestionAnswerRequest } from '../../actionCreators/bazaarVoiceQuestionAnswer/bazaarVoiceQuestionAnswerActionCreators'
import QandA from './QandA'

export class QandAContainer extends Component {
  componentDidMount = () => {
    this.getBVQuestionAnswerData()
  }

  componentDidUpdate = prevProps => {
    const hasChanged = this.props.partNumber !== prevProps.partNumber
    if (hasChanged) {
      this.getBVQuestionAnswerData()
    }
  }

  getBVQuestionAnswerData = () => {
    const { partNumber, requestBVQuestionAnswerData } = this.props

    const query = {
      Limit: 10,
      Offset: 0,
      Sort: 'SubmissionTime:Desc',
      Search: undefined
    }
    const payload = {
      partNumber,
      query
    }

    requestBVQuestionAnswerData(payload)
  }

  render = () => {
    const { ASK_QUESTION, questions } = this.props
    const shouldShowQuestions = questions.length > 0 || ASK_QUESTION
    return <>{shouldShowQuestions && <QandA {...this.props} />}</>
  }
}

export const mapStateToProps = (state, ownProps) => {
  const { partNumber } = ownProps
  const { bazaarVoiceQuestionAnswer = {} } = state
  const { data = {}, meta = {} } = bazaarVoiceQuestionAnswer
  const { productQuestions = {}, productPaginatedQuestions = {}, searchTerm, stats = {} } = data
  const questions = productQuestions[partNumber] || ownProps.questions || []
  const error = meta[partNumber] || {}
  const paginatedQuestion = productPaginatedQuestions[partNumber] || []
  const hasError = error.errorDetail || (paginatedQuestion.length < 1 && questions.length >= 1)
  const props = {
    ...ownProps,
    questions,
    paginatedQuestion,
    searchTerm,
    stats,
    hasError
  }
  return props
}

export const mapDispatchToProps = dispatch => {
  const requestBVQuestionAnswerData = payload => dispatch(fetchBVQuestionAnswerRequest(payload))
  const props = { requestBVQuestionAnswerData }
  return props
}

export default connect(mapStateToProps, mapDispatchToProps)(QandAContainer)
